import custom_axios from "../axios";

export const GET_OVERVIEW = async (currStart,currEnd,prevStart,prevEnd)=> {
    try {
        const response = await custom_axios.get(`/analytics/overview?currStart=${currStart}&currEnd=${currEnd}&prevStart=${prevStart}&prevEnd=${prevEnd}`);
        return response.data;
    } catch (error) {
        console.error("Failed to get overview:", error);
        throw error;
    }
};

export const GET_LEADERBOARD = async (currStart,currEnd,prevStart,prevEnd)=> {
    try {
        const response = await custom_axios.get(`/analytics/leaderboard?currStart=${currStart}&currEnd=${currEnd}&prevStart=${prevStart}&prevEnd=${prevEnd}`);
        return response.data;
    } catch (error) {
        console.error("Failed to get leaderboard:", error);
        throw error;
    }
}

export const GET_ASSIGNMENTS = async (currStart,currEnd)=> {
    try {
        const response = await custom_axios.get(`/analytics/assignments?currStart=${currStart}&currEnd=${currEnd}`);
        return response.data;
    } catch (error) {
        console.error("Failed to get assignments:", error);
        throw error;
    }
}